module.exports = __webpack_public_path__ + "static/media/BagIcon.824e390c.svg";